import script from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteModal.vue?vue&type=style&index=0&id=42452eea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42452eea"]])

export default __exports__